import Vue from 'vue'
import Vuel18n from 'vue-i18n'

Vue.use(Vuel18n)
export const i18n = new Vuel18n({
  locale: 'en',
  fallbackLocale: 'en'
})



// WEBPACK FOOTER //
// ./src/plugins/i18n.js